import React, { useEffect, useState } from "react";
import { Col } from "react-bootstrap";
import { Branch, Block, AttachBlock } from "./Tools";
import { actions } from "../../store/workflow.store";
import { FormattedMessage, injectIntl } from "react-intl";

function LinkedinTemplate({
  blockOptions,
  handleSettingsToggle,
  template,
  activeBlockId,
  closeSettingsToggle,
  intl,
}) {
  const getBlock = (id) => {
    return template.blocks.find((block) => block.id == id);
  };
  const expandStyle = {
    width: "190%",
    left: "-110px",
    position: "relative",
  };
  return (
    <div className="workflow-tree-structure ">
      <div
        className={"overlay-block expand " + (blockOptions ? "active" : "")}
        onClick={() => closeSettingsToggle()}
      />
      <Block
        icon={"ic_linkedin_popup_active.png"}
        blockOptions={{
          ...getBlock(1),
          name: intl.formatMessage({ id: "workflow.linkedinInvitation" }),
        }}
        active={activeBlockId == 1 && blockOptions.action == "linkedin-invite"}
        onClick={handleSettingsToggle}
      />
      {/*WORKFLOW TREE LINES*/}
      <Branch
        blockOptions={getBlock(2)}
        onClick={handleSettingsToggle}
        active={activeBlockId == 2}
        showSetTimeText
        textSwitch
      />
      {/*Left*/}
      <div className="workflow-tree-columns-outer">
        {/*Right*/}
        <div className="workflow-column workflow-messages-column">
          <div className="workflow-tree">
            <Block
              icon={"ic_linkedin_message.png"}
              hideLimit
              blockOptions={{
                ...getBlock(9),
                name: intl.formatMessage({ id: "workflow.linkedinMessage" }),
              }}
              active={activeBlockId == 9}
              onClick={handleSettingsToggle}
            />
            <Branch
              blockOptions={getBlock(10)}
              onClick={handleSettingsToggle}
              active={activeBlockId == 10}
              textSwitch
              isMessage
            />
            <div className="workflow-tree-columns-outer">
              <div className="workflow-column">
                <div className="workflow-tree">
                  <AttachBlock
                    blockOptions={getBlock(15)}
                    onClick={handleSettingsToggle}
                    active={activeBlockId == 15}
                  />
                </div>
              </div>
              <div className="workflow-column">
                <div className="workflow-tree ">
                  <Block
                    icon={"ic_linkedin_message.png"}
                    hideLimit
                    blockOptions={{
                      ...getBlock(11),
                      name: intl.formatMessage({
                        id: "workflow.linkedinMessage",
                      }),
                    }}
                    active={activeBlockId == 11}
                    onClick={handleSettingsToggle}
                  />
                  <div style={expandStyle}>
                    <Branch
                      blockOptions={getBlock(12)}
                      onClick={handleSettingsToggle}
                      active={activeBlockId == 12}
                      isMessage
                    />
                    <div className="workflow-tree-columns-outer">
                      <div className="workflow-column">
                        <div className="workflow-tree">
                          <AttachBlock
                            blockOptions={getBlock(13)}
                            onClick={handleSettingsToggle}
                            active={activeBlockId == 13}
                          />
                        </div>
                      </div>
                      <div className="workflow-column">
                        <div className="workflow-tree">
                          <AttachBlock
                            blockOptions={getBlock(14)}
                            onClick={handleSettingsToggle}
                            active={activeBlockId == 14}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="workflow-column">
          <div className="workflow-tree">
            <AttachBlock
              blockOptions={getBlock(30)}
              onClick={handleSettingsToggle}
              active={activeBlockId == 30}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
LinkedinTemplate = injectIntl(LinkedinTemplate);
function EnrichementTemplate({
  active,
  handleSettingsToggle,
  blockOptions,
  template,
  activeBlockId,
}) {
  const getBlock = (id) => {
    return template.blocks.find((block) => block.id == id);
  };
  return (
    <div className="workflow-tree-structure ">
      <div
        className={"overlay-block expand " + (blockOptions ? "active" : "")}
      ></div>
      <div className="one-workflow-block">
        <div className="workflow-container">
          <div className="workflow-line"></div>
          <div
            className={
              "workflow-content " +
              (activeBlockId && !blockOptions.attached ? "active" : "")
            }
            onClick={() => handleSettingsToggle(getBlock(1))}
          >
            <div>
              <img
                style={{ marginRight: 10, width: 25 }}
                src="/assets/images/kaspr-plugin.png"
                alt=""
              />
            </div>
            <div className="content-block">
              <p>Kaspr</p>
              <span>
                <FormattedMessage id={"workflow.enrichLinkedin"} />
              </span>
            </div>
            <div className="tooltip-box">
              <p>
                <FormattedMessage id={"workflow.step1EditThis"} />
              </p>
            </div>
          </div>
        </div>
      </div>
      <AttachBlock
        blockOptions={getBlock(2)}
        onClick={handleSettingsToggle}
        active={activeBlockId && blockOptions.attached}
        isEnrich
      />
    </div>
  );
}
EnrichementTemplate = injectIntl(EnrichementTemplate);
function IntegrationTemplate({
  active,
  activeBlockId,
  handleSettingsToggle,
  blockOptions,
  template,
  integrationName,
}) {
  const [name, setName] = useState("");
  useEffect(() => {
    if (integrationName) {
      setName(integrationName);
    } else {
      setName(
        template.blocks.find((block) => (block.type = "flow_input")).name
      );
    }
  }, []);
  const getBlock = (id) => {
    return template.blocks.find((block) => block.id == id);
  };

  return (
    <div className="workflow-tree-structure ">
      <div
        className={"overlay-block expand " + (blockOptions ? "active" : "")}
      ></div>
      <div className="one-workflow-block">
        <div className="workflow-container">
          <div className="workflow-line"></div>
          <div
            className={"workflow-content " + (activeBlockId ? "active" : "")}
            onClick={() => handleSettingsToggle(getBlock("1"))}
          >
            <div className="icon-block no-bg">
              <img src={"/assets/images/" + name + "-icon.png"} alt="" />
            </div>
            <div className="content-block">
              <p>{name}</p>
              <span className="connected-tag">
                <FormattedMessage id={"workflow.connected"} />
              </span>
            </div>
            <div className="tooltip-box">
              <p>
                <FormattedMessage id={"workflow.step1EditThis"} />
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
IntegrationTemplate = injectIntl(IntegrationTemplate);
export { LinkedinTemplate, EnrichementTemplate, IntegrationTemplate };
